var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Heading',{attrs:{"page":_vm.page}}),_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"Design","name":"Design"}},[_c('home')],1),_c('el-tab-pane',{attrs:{"label":"Preview","name":"Preview"}},[_c('preview')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }